import React from 'react';

import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { CustomPagination } from 'common/components';

import * as selectors from '../../selectors';

import CustomTemplateColumns from './CustomTemplateColumns';

const CustomTemplatesTab = ({
    clonePages,
    customTemplate,
    handleSelectPage,
    isFetchingCustomTemplate,
}) => {
    const filteredItems = clonePages.filter(
        (item) =>
            item.pages >= 1 && item?.language === customTemplate?.language,
    );

    const pageSizeOptions = [20, 50, 100];

    const columns = CustomTemplateColumns();

    const getRowHeight = () => 'auto';
    const initialState = {
        pagination: {
            paginationModel: { pageSize: pageSizeOptions[0] },
        },
    };
    const onRowSelectionModelChange = (newSelectionModel) => {
        const selectedIDs = new Set(newSelectionModel);
        const selectedRowData = filteredItems.filter((row) =>
            selectedIDs.has(row.id.toString()),
        );

        if (selectedRowData[0]) {
            handleSelectPage({
                id: selectedRowData[0]?.id,
                pages: selectedRowData[0]?.pages,
            });
        }
    };

    const slotProps = { pagination: { pageSizeOptions } };
    const slots = { pagination: CustomPagination };

    return (
        <DataGrid
            columns={columns}
            disableColumnMenu
            getRowHeight={getRowHeight}
            initialState={initialState}
            loading={isFetchingCustomTemplate}
            onRowSelectionModelChange={onRowSelectionModelChange}
            pagination
            rows={filteredItems}
            slotProps={slotProps}
            slots={slots}
        />
    );
};

const mapStateToProps = createStructuredSelector({
    clonePages: selectors.getfetchTemplateCatalogsData,
    customTemplate: selectors.getDatafetchTemplate,
    isFetchingCustomTemplate: selectors.getIsFetchingCustomTemplate,
});

CustomTemplatesTab.propTypes = {
    clonePages: PropTypes.array,
    customTemplate: PropTypes.object,
    handleSelectPage: PropTypes.func,
    isFetchingCustomTemplate: PropTypes.bool,
};

export default connect(mapStateToProps, null)(CustomTemplatesTab);
